import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";

const VehicleEntry = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    console.log(data);
    try {
      const sendRequest = await axios.post(`${process.env.REACT_APP_API_URL}/track/vehicleTrack`, data);
      if(sendRequest.data.success){
        alert('Vehicle Registered Successfully');
      }
      reset();
    } catch (error) {
      alert(error?.response?.data?.message ||"Failed to submit vehicle.");
      console.error(error);
    }
  };

  return (
    <div className="w-full mx-auto p-4 border rounded shadow my-4 scroll-auto">
      <h2 className="text-2xl font-bold mb-6 text-center">Add Vehicle</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Vehicle Number */}
        <div>
          <label className="block font-semibold">Vehicle Number
            <span className="text-red-500 fixed h-3">*</span>
          </label>
          <input
            {...register("vehicleNumber", { required: "Vehicle Number is required" })}
            className="w-full p-2 border rounded"
          />
          {errors.vehicleNumber && <p className="text-red-600 text-sm">{errors.vehicleNumber.message}</p>}
        </div>

        {/* Vehicle Type */}
        <div>
          <label className="block font-semibold">Vehicle Type</label>
          <input {...register("vehicleType")} className="w-full p-2 border rounded" />
        </div>

        {/* Driver Name */}
        <div>
          <label className="block font-semibold">Driver Name
            <span className="text-red-500 fixed h-3">*</span>
          </label>
          <input
            {...register("driverName", { required: "Driver Name is required" })}
            className="w-full p-2 border rounded"
          />
          {errors.driverName && <p className="text-red-600 text-sm">{errors.driverName.message}</p>}
        </div>

        {/* Driver Contact */}
        <div>
          <label className="block font-semibold">Driver Contact
            <span className="text-red-500 fixed h-3">*</span>
          </label>
          <input
            {...register("driverContact", { required: "Driver Contact is required" })}
            className="w-full p-2 border rounded"
          />
          {errors.driverContact && <p className="text-red-600 text-sm">{errors.driverContact.message}</p>}
        </div>

        {/* Transporter Name */}
        <div>
          <label className="block font-semibold">Transporter Name</label>
          <input {...register("transporterName")} className="w-full p-2 border rounded" />
        </div>

        {/* Source Latitude */}
        <div>
          <label className="block font-semibold">Source Latitude*</label>
          <input
            {...register("srcLatitude", { required: "Source Latitude is required" })}
            className="w-full p-2 border rounded"
          />
          {errors.srcLatitude && <p className="text-red-600 text-sm">{errors.srcLatitude.message}</p>}
        </div>

        {/* Source Longitude */}
        <div>
          <label className="block font-semibold">Source Longitude
            <span className="text-red-500 fixed h-3">*</span>
        </label>
          <input
            {...register("srcLongitude", { required: "Source Longitude is required" })}
            className="w-full p-2 border rounded"
          />
          {errors.srcLongitude && <p className="text-red-600 text-sm">{errors.srcLongitude.message}</p>}
        </div>
        {/* Submit Button */}
        <div className="col-span-full">
          <button
            type="submit"
            className="tracking-widest text-dark bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full  px-5 py-2.5 text-center"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default VehicleEntry;
